import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c159bfde&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=c159bfde&prod&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=c159bfde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159bfde",
  null
  
)

export default component.exports